// extracted by mini-css-extract-plugin
export default {"parallax":"Parallax_parallax__l6In+","parallaxInner":"Parallax_parallaxInner__EQhyg"};